module.exports = __webpack_public_path__ + "static/media/credit_card_black.619d17a0.png";